export const TID = {
  // global
  langSwitch: "lang-switcher",
  navHome: "nav-home",
  navAcademy: "nav-academy",
  navMusic: "nav-music",
  navDance: "nav-dance",
  navWorkshops: "nav-workshops",
  navEvents: "nav-events",
  navTeachers: "nav-teachers",
  navGallery: "nav-gallery",
  navContact: "nav-contact",
  navEnroll: "nav-enroll",
  mobileMenuToggle: "mobile-menu-toggle",
  footerAbout: "footer-about",

  // home
  heroEnrollBtn: "hero-enroll-btn",
  heroDiscoverBtn: "hero-discover-btn",
  homeMusicCard: "home-music-card",
  homeDanceCard: "home-dance-card",
  ctaEnrollBtn: "cta-enroll-btn",

  // department
  deptEnrollBtn: "dept-enroll-btn",

  // enroll form
  enrollFirstName: "enroll-first-name",
  enrollLastName: "enroll-last-name",
  enrollBirthDate: "enroll-birth-date",
  enrollParentName: "enroll-parent-name",
  enrollPhone: "enroll-phone",
  enrollEmail: "enroll-email",
  enrollAddress: "enroll-address",
  enrollCategory: "enroll-category",
  enrollCourse: "enroll-course",
  enrollNote: "enroll-note",
  enrollPrivacy: "enroll-privacy",
  enrollSubmit: "enroll-submit",

  // contact
  contactName: "contact-name",
  contactEmail: "contact-email",
  contactMessage: "contact-message",
  contactSubmit: "contact-submit",

  // admin
  adminEmail: "admin-email",
  adminPassword: "admin-password",
  adminLoginBtn: "admin-login-btn",
  adminLogoutBtn: "admin-logout-btn",
  adminSidebarDashboard: "admin-sb-dashboard",
  adminSidebarStudents: "admin-sb-students",
  adminSidebarTeachers: "admin-sb-teachers",
  adminSidebarCourses: "admin-sb-courses",
  adminSidebarWorkshops: "admin-sb-workshops",
  adminSidebarEvents: "admin-sb-events",
  adminSidebarEnrollments: "admin-sb-enrollments",
  adminSidebarAttendance: "admin-sb-attendance",
  adminSidebarPayments: "admin-sb-payments",
  adminSidebarSettlements: "admin-sb-settlements",
  adminSidebarGallery: "admin-sb-gallery",
};
